import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/webPanel/NoticeBoard.css';

const NoticeBoard = ({setLoading}) => {
  const [showNotice, setShowNotice] = useState(false);
  const [formData, setFormData] = useState({
    date: '',
    tagline: '',
    description: '',
  });

  const [responseMsg, setResponseMsg] = useState('');
  const [notice, setNotice] = useState([]);
  const [selectedNotice, setSelectedNotice] = useState('');
  const [showDelNotice, setShowDelNotice] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

                const fetchNotice = async () => {
                  setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-notice');
      
                      if (response.ok) {
                          const data = await response.json();
 data.sort((a, b) => new Date(b.date) - new Date(a.date));
 setNotice(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch coupon');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
              };
      

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('https://api.kcian.in/add-notice', formData);
      setResponseMsg('Notice added successfully!', );
      setFormData({ date: '', tagline: '', description: '' });
      fetchNotice();
      setShowNotice(false);
    } catch (error) {
      console.error('Error submitting notice:', error);
      setResponseMsg('Something Went Wrong. Please try again.');
    }

    setTimeout(() => setResponseMsg(''), 4000);
  };


          useEffect(() => {
              fetchNotice();
          }, []);


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  const handleShowDelete = (notice) => {
    setSelectedNotice(notice);
    setShowDelNotice(true);
  }

            const handleDelete = async (noticeId) => {
    try {
      const response = await fetch(`https://api.kcian.in/remove-notice/${noticeId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setNotice((prevProducts) => prevProducts.filter((notice) => notice.id !== noticeId));
        setShowDelNotice(false);
        setResponseMsg('Notice deleted successfully!');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);
      } else {
      setResponseMsg('Something Went Wrong. Please try again.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  return (
    <>
      <section className='my-5'>
        <div className='container'>
          <p className='page-heading'>Notice Board</p>
          <hr />

          <div className='text-end'>
            <button className='notice-btn' onClick={() => setShowNotice(true)}>
              <i className="fa-solid fa-pen-to-square"></i> New Notice
            </button>
          </div>

                    {responseMsg && (
            <div className='alert alert-success fw-semibold border-0  mt-2'>{responseMsg}</div>
          )}


          {showNotice && (
            <div className='notice-card my-3'>
              <p className='fw-bold'>Add New Notice</p>
              <form onSubmit={handleSubmit}>
                <div className='mb-3'>
                  <label htmlFor='date' className='login-label'>Date*</label>
                  <input
                    type='datetime-local'
                    className='login-control'
                    name='date'
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className='mb-3'>
                  <label htmlFor='tagline' className='login-label'>Tagline*</label>
                  <input
                    type='text'
                    className='login-control'
                    name='tagline'
                    placeholder='Enter a short title or headline'
                    value={formData.tagline}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className='mb-3'>
                  <label htmlFor='description' className='login-label'>Description*</label>
                  <textarea
                    className='login-control'
                    name='description'
                    rows='4'
                    placeholder='Brief your notice here..'
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />
                </div>

                  <button type='submit' className='notice-btn2 me-2'>
                    Submit
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowNotice(false)}>
                    Cancel
                  </button>

              </form>
            </div>
          )}


              {notice.map(notices => (
<div className='notice-card my-3'>
<p className='fw-bold fm-mont my-1'>{notices.tagline}</p>
    <p className='para-text text-muted fw-semibold'>Date Posted On: {formatDateTime(notices.date)}</p>
<p className='text-muted fm-mont'>{notices.description}</p>

<button className='notice-btn' onClick={() => handleShowDelete(notices)}>Delete Notice</button>
</div>
              ))}

        </div>
      </section>

{showDelNotice && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Delete Notice '{selectedNotice.tagline}'?</p>

                  <button type='submit' className='notice-btn2 me-2' onClick={() => handleDelete(selectedNotice.id)}>
                    Yes
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowDelNotice(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}

    </>
  );
};

export default NoticeBoard;
